import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as History } from 'assets/svg/icon-history.svg'

function IconHistory(props: IconProps): JSX.Element {
  const title = 'icon-history'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <History {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconHistory
